/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconArrowDownLeft = createReactComponent("outline", "arrow-down-left", "IconArrowDownLeft", [["path", { "d": "M17 7l-10 10", "key": "svg-0" }], ["path", { "d": "M16 17l-9 0l0 -9", "key": "svg-1" }]]);

export { IconArrowDownLeft as default };
//# sourceMappingURL=IconArrowDownLeft.mjs.map
